<template>
<div>
  <h6>Photo Upload</h6>
  <div v-if="state === 'CHECK'">
    <b-alert id='user-reminder' variant="info" show>Do you wish to run task to import data from file?</b-alert>
    <b-button class="btn-xs" variant="primary" v-on:click.prevent="state = 'DEFAULT'">No</b-button>
    <b-button class="btn-xs" variant="primary" v-on:click.prevent="addTask">Yes</b-button>
  </div>
  <file-uploader :scriptId="158" ref="fUploader" v-model="inputFiles[158]"></file-uploader>
  <!-- <b-form-file v-if="state === 'DEFAULT'" accept=".zip" v-model="file" placeholder="Choose a file..."></b-form-file> -->
  <div class="upload-check-container" v-if="file">
    <span>Upload this file?</span>
    <b-button type="submit" variant="primary" @click="upload">Upload</b-button>
  </div>

</div>
</template>
<script>
import Vue from 'vue'
import TasksPlugin from '../../../plugin/tasks'
import FileUploader from '../../FileUploader'

export default {
  data() {
    return {
      file: null,
      scripts: [],
      state: 'DEFAULT',
      addAllowed: true,
      inputFiles: {

      },
      predefinedParams: {

      }
    }
  },
  components: {
    FileUploader
  },
  computed: {
    currentProject () {
      return this.$store.getters['project/currentProject']
    }
  },
  mounted () {
    Vue.use(TasksPlugin)
    this.$tasksService.loadScripts(this)
  },
  methods: {
    loadScripts () {
      // this.$tasksService.loadScripts(this, scripts => {
      //   scripts.forEach(s => {
      Vue.set(this.inputFiles, 158, '')
      // Vue.set(this.tasksToAdd, 158, false)
      //   })
      // })
    },
    upload() {
      let user = this.$store.getters['user/user']
      let formData = new FormData();
      formData.append('file', this.file);
      let me = this
      this.$http.post('/api/admin-board/upload-standard-data/?user_name='+user.username, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.$notify({
          title: 'SUCCESS',
          text: 'Data upload successful',
          type: 'success'
        })
        me.file = null
        me.state = 'CHECK'
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not upload data',
          type: 'error'
        })
        this.loading = false
      })
    },
    addTask () {
      let payload = {}
      this.state = 'DEFAULT'
      // TODO get required task id and add to payload
      payload['ids'] = [{id: 158, params: {}}]
      payload['project_id'] = this.currentProject.id
      payload['workpack_id'] = this.currentProject.workpack.id

      this.$tasksService.addTasks(this, payload)
    },
    validateInputFiles () {
      this.addAllowed = true
      Object.keys(this.tasksToAdd).forEach(k => {
        if (this.tasksToAdd[k] && typeof this.inputFiles[k] !== 'undefined' && !this.inputFiles[k]) {
          this.addAllowed = false
        }
      })
    },
  },
  watch: {
    inputFiles: {
      handler: function () {
        this.validateInputFiles()
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/PhotoUpload.vue